var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCrossDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.868164,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#232A37"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.85477,
    height: 0.981846,
    rx: 0.490923,
    transform: "matrix(0.704575 -0.709629 0.704575 0.709629 5.98828 12.2275)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.85477,
    height: 0.981846,
    rx: 0.490923,
    transform: "matrix(0.704575 0.709629 -0.704575 0.709629 6.47852 6.81348)",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCrossDark);
export default __webpack_public_path__ + "static/media/circle-cross-dark.afde520a0be000edd6788b5523a5c726.svg";
export { ForwardRef as ReactComponent };